import {DBBase} from './DBBase';

export class DBEmailLogs extends DBBase {
    /**
     * @param {Object} component
     */
    constructor(component) {
        super(
            component,
            '/email-logs'
        );
    }
}
